// Vuex
import store from '@/store.js';
// i18n
import i18n from '@/i18n';
// Self-made Snackbar
import snackbar from '@/plugins/snackbar';

import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/shops/", data);
}

async function fetchForSelect(data) {
    return Request('get', "api/shops/select", data);
}


async function fetchOne(id) {// 获取单个
    return Request('get', "api/shops/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/shops", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "shop_code", "shop_name","status", "company_name"]; //仅筛选少许必要字段
    return Request('get', "api/shops/select", data, false, false, true);
}

async function fetchFiveForSelect(data) {
    if (!data) data = {};
    data.limit = 5; //获取5条数据
    data.fieldFilter = ["id", "shop_code", "shop_name","status", "company_name"]; //仅筛选少许必要字段
    return Request('get', "api/shops/select", data, false, false, true);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/shops/edit?id=" + id, data);
    } else {
        return Request('post', "api/shops/add" , data);
    }
}

async function exports(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function imports(file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/shops/import", data);
}

async function editBalance(data) {
    return Request('get', "api/shops/edit-balance/", data);
}

async function accountHistory(data) {
    return Request('get', "api/shops/get-shop-balance-histories" , data);
}

async function fpBatchPush() {
    return Request('get', "api/shops/fpSyncShop");
}

async function shopPsiMaterialCategoyies(data) {//门店进销存商品分类列表
    return Request('get', "api/shops/shop-psi-material-categoyies" ,data);
}

async function shopPsiMaterials(data) {//门店进销存商品列表
    return Request('get', "api/shops/shop-psi-materials",data);
}

async function shopPsi(data) {//门店进销存库存列表
    return Request('get', "api/shops/shop-psi", data);
}

async function shopPsiDetail(data) {//门店进销存出入库明细
    return Request('get', "api/shops/shop-psi-detail", data);
}

async function shopPsiDetailExports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/shops/shop-psi-detail-export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function shopPsiCurrentStockExports(data) {
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/psi-shops/shop-psi-current-stock-export', data)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}
  
async function shopBalanceExport(data) {// 导出资金账户报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-balance-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function balanceTemplateExport(data) {// 批量充值余额模板导出
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/balance-template-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function balanceTemplateImport(file) {// 批量充值余额模板导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/shops/balance-template-import", data);
}

async function shopBalanceHistoryExport(data) {// 导出资金账户报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-balance-history-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function shopPsiStockOrderExport(data) {// 导出门店出入库汇总
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/psi-shops/shop-psi-stock-order-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function checkShopPsiOpen() {
    return Request('get', "api/shops/check-shop-psi-open");
}

async function addPsiDate(data) {
    return Request('post', "api/shops/add-psi-lifespan" , data);
}

async function getWxQrCode(Id) {
    return Request('get', "api/shops/get-wx-qr-code/" + Id);
}

async function getShopBalanceSnapshots(data) {
    return Request('get', "api/shops/shop-balance-snapshots",data);
}

async function shopBalanceSnapshotExport(data) {// 导出报表
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-balance-snapshot-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}
async function shopStockTakeOrders(data) {
    return Request('get', "api/shops/shop-stock-take-orders", data);
}

async function shopStockTakeOrdersDetails(data) {
    return Request('get', "api/shops/shop-stock-take-orders-details", data);
}

async function shopStockTakeOrdersDetailsExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-stock-take-orders-details-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function shopStockOrdersIn(data) {
    return Request('get', "api/shops/shop-stock-orders-in", data);
}

async function shopStockOrdersInDetails(data) {
    return Request('get', "api/shops/shop-stock-orders-in-details", data);
}

async function shopStockOrdersInExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-stock-orders-in-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function shopStockOrdersInDetailExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-stock-orders-in-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function shopStockOrdersOut(data) {
    return Request('get', "api/shops/shop-stock-orders-out", data);
}

async function shopStockOrdersOutDetails(data) {
    return Request('get', "api/shops/shop-stock-orders-out-details", data);
}

async function shopStockOrdersOutExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-stock-orders-out-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function shopStockOrdersOutDetailExport(data) {
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/shops/shop-stock-orders-out-detail-export", data);
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function returnOrderView(data) {
    return Request('get', "api/shops/shop-stock-return-orders-view", data);
}

async function fetchLabels() {
    return Request('get', "api/shops/get-filed-selects", {field_names: ['label']});
}

async function syncThirdShop() {
    return Request('get', "api/shops/sync-third-shop");
}

async function serviceChargeSetting(data) {
    return Request('post', "api/shops/shop-service-charge-setting", data);
}

async function viewFreeMaterials(id) {
    return Request('get', "api/shops/view-free-materials/" + id);
}

async function syncHuaManLouShops() {
    return Request('get', "api/shops/sync-hua-man-lou-shops/");
}

async function updateActualDate(data) {
    return Request('post', "api/shops/update-actual-date" , data);
}

async function getAllianceBusinesses(data) {
    return Request('get', "api/shops/get-alliance-businesses", data);
}

async function getSockDistributionConfigs(data) {
    return Request('get', "api/shops/get-stock-distribution-configs", data);
}

async function getSockDistributionConfigsMaterials(data) {
    return Request('get', "api/shops/get-stock-distribution-configs-materials", data);
}

async function getOrderRulers(data) {
    return Request('get', "api/shops/get-order-rulers", data);
}


export default {
    fetch,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    fetchFiveForSelect,
    save,
    exports,
    imports,
    editBalance,
    accountHistory,
    fpBatchPush,
    shopPsiMaterialCategoyies,
    shopPsiMaterials,
    shopPsi,
    shopPsiDetail,
    shopPsiDetailExports,
    shopBalanceExport,
    balanceTemplateExport,
    balanceTemplateImport,
    shopBalanceHistoryExport,
    shopPsiStockOrderExport,
    shopPsiCurrentStockExports,
    checkShopPsiOpen,
    addPsiDate,
    fetchForSelect,
    getWxQrCode,
    getShopBalanceSnapshots,
    shopBalanceSnapshotExport,
    shopStockTakeOrders,
    shopStockTakeOrdersDetails,
    shopStockTakeOrdersDetailsExport,
    shopStockOrdersIn,
    shopStockOrdersInDetails,
    shopStockOrdersInExport,
    shopStockOrdersInDetailExport,
    shopStockOrdersOut,
    shopStockOrdersOutDetails,
    shopStockOrdersOutExport,
    shopStockOrdersOutDetailExport,
    returnOrderView,
    fetchLabels,
    syncThirdShop,
    serviceChargeSetting,
    viewFreeMaterials,
    syncHuaManLouShops,
    updateActualDate,
    getAllianceBusinesses,
    getSockDistributionConfigs,
    getSockDistributionConfigsMaterials,
    getOrderRulers,
};